import React, { useState } from 'react';
import {
  Form,
  Button,
  Card,
  Select,
  Space,
  message,
  Layout,
  Typography
} from 'antd';
import {
  LeftOutlined,
  SaveOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { get } from '../utils/api';

const { Header, Content } = Layout;
const { Title } = Typography;
const { Option } = Select;

const Wizard = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      console.log('Wizard表单数据:', values);

      // 构建API URL参数
      const params = new URLSearchParams({
        riskRating: values.riskRating,
        filter1: '1',
        value1: values.climateChange,
        filter2: '2',
        value2: values.impactInvesting,
        filter3: '3',
        value3: values.techThemes
      });

      // 使用API工具类调用API获取portfolio ID
      // 401错误会自动被拦截并跳转到登录页面
      const portfolioId = await get(`/api/etfportfoliolist/esgWizardPortfolioId?${params.toString()}`);

      if (portfolioId) {
        message.success(t('wizard.submitSuccess'));

        // 保存portfolioId到localStorage以便后续页面使用
        localStorage.setItem('portfolioId', portfolioId);

        // 模拟处理时间后跳转到portfolio详情页面
        setTimeout(() => {
          navigate('/portfolio');
        }, 1000);
      } else {
        message.error(t('wizard.submitFailed'));
      }
    } catch (error) {
      console.error('提交失败:', error);
      message.error(t('wizard.submitFailed'));
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{
        background: '#fff',
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
          {t('wizard.title')}
        </Title>
        <Space>
          <LanguageSwitcher />
        </Space>
      </Header>

      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
        <Card style={{ maxWidth: 600, margin: '0 auto' }}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            size="large"
            initialValues={{
              riskRating: 5,
              climateChange: 2,
              impactInvesting: 2,
              techThemes: 2
            }}
          >
            {/* Risk Rating */}
            <Form.Item
              name="riskRating"
              label={t('wizard.riskRating')}
              rules={[{ required: true, message: t('wizard.riskRatingRequired') }]}
            >
              <Select
                placeholder={t('wizard.riskRatingPlaceholder')}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                  <Option key={value} value={value}>
                    {value} - {t(`wizard.riskRating${value}`)}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Climate Change */}
            <Form.Item
              name="climateChange"
              label={t('wizard.climateChange')}
              rules={[{ required: true, message: t('wizard.climateChangeRequired') }]}
            >
              <Select
                placeholder={t('wizard.climateChangePlaceholder')}
              >
                {[1, 2, 3].map((value) => (
                  <Option key={value} value={value}>
                    {value} - {t(`wizard.climateChange${value}`)}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Impact Investing */}
            <Form.Item
              name="impactInvesting"
              label={t('wizard.impactInvesting')}
              rules={[{ required: true, message: t('wizard.impactInvestingRequired') }]}
            >
              <Select
                placeholder={t('wizard.impactInvestingPlaceholder')}
              >
                {[1, 2, 3].map((value) => (
                  <Option key={value} value={value}>
                    {value} - {t(`wizard.impactInvesting${value}`)}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Tech Themes */}
            <Form.Item
              name="techThemes"
              label={t('wizard.techThemes')}
              rules={[{ required: true, message: t('wizard.techThemesRequired') }]}
            >
              <Select
                placeholder={t('wizard.techThemesPlaceholder')}
              >
                {[1, 2, 3].map((value) => (
                  <Option key={value} value={value}>
                    {value} - {t(`wizard.techThemes${value}`)}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* 按钮组 */}
            <Form.Item style={{ marginTop: '32px' }}>
              <Space size="large">
                <Button
                  size="large"
                  icon={<LeftOutlined />}
                  onClick={handleBack}
                >
                  {t('wizard.back')}
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  size="large"
                  icon={<SaveOutlined />}
                >
                  {t('wizard.submit')}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Card>
      </Content>
    </Layout>
  );
};

export default Wizard;